module.exports = __webpack_public_path__ + "static/img/no.aaef36f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/f1/no.png
// module id = 66U3
// module chunks = 0